import React from 'react';
import {Button, Modal} from 'antd';

import SPButton from "../../../carRental/base/SPButton";
import {useTakeTheLead} from "../../../../hooks/actives/take-the-lead";

interface IComponentProps {
  data?: any;
  permission?: any;
}
const SPTableActionBar: React.FC<IComponentProps> = (props) => {
  const { data, permission } = props

  const { tableActionEdit, tableActionView,tableActionAdd,  tableActionOut} = useTakeTheLead();


    // todo: hard code

  const onEdit = () => {
    tableActionEdit(data)
  };

  const onAdd = async () => {
    tableActionAdd(data)
  }

  const onView = () => {
      tableActionView(data)
  };


  const onQuit = () => {
    tableActionOut(data)

  }
  return (
    <>
          {
            data.reg_code ?  <SPButton permissionKey='view-fore-pit'  permission={permission} type="link"  onClick={onView}>查看</SPButton> : null
          }
          {
            data?.reg_code ?
              <SPButton permissionKey='edit-fore-pit'   permission={permission} type="link"  onClick={onEdit}>{
                data.status === 1 ? '编辑' : '报名参与'
              }</SPButton> :
              <SPButton permissionKey='join-fore-pit'   permission={permission} type="link"  onClick={onAdd}>{
                '报名参与'
              }</SPButton>
          }
          {
            data.reg_code && data.status === 1 ?  <SPButton permissionKey='out-fore-pit'  permission={permission} type="link"  onClick={onQuit}>退出</SPButton> : null
          }

    </>
  );
};

export default SPTableActionBar;
